import { jsx } from "react/jsx-runtime";
import { DataBindingProvider, EntityListSubTree } from "@contember/binding";
import { memo } from "react";
import { getPageName } from "./getPageName.js";
import { MutableEntityListPageRenderer } from "../../bindingFacade/renderers/pageRenderers/MutableEntityListPageRenderer.js";
import { FeedbackRenderer } from "../../bindingFacade/renderers/FeedbackRenderer.js";
const MultiEditPage = memo(
  ({
    children,
    rendererProps,
    pageName,
    ...entityListProps
  }) => /* @__PURE__ */ jsx(DataBindingProvider, { stateComponent: FeedbackRenderer, children: /* @__PURE__ */ jsx(EntityListSubTree, { ...entityListProps, listComponent: MutableEntityListPageRenderer, listProps: rendererProps, children }) })
);
MultiEditPage.getPageName = getPageName;
export {
  MultiEditPage
};
//# sourceMappingURL=MultiEditPage.js.map
